<template lang="pug">
  hr(:class="classes").v-divider
</template>

<script>
export default {
  name: 'VDivider',

  props: {
    secondary: Boolean,
    thin: Boolean
  },

  computed: {
    classes () {
      return {
        'mt-3 mb-3': !this.secondary && !this.thin,
        'v-divider--secondary': this.secondary,
        'v-divider--thin': this.thin
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/sass/abstracts/_variables.scss';

  .v-divider {
    border: .1rem solid $color-primary;

    &--secondary {
      border: .2rem solid $color-divider;
    }

    &--thin {
      border: .1rem solid $color-divider;
    }
  }
</style>
